import { Repeat } from '@griply/assets';
import { getHabitEndedDate, getHabitEndedLabel } from '@griply/utils';
import { Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Colors, Sizes, Variants } from 'shared/components/ui/button';
import { useToday } from 'shared/contexts/today';
import { Task } from 'shared/types/task';
import { formatDateKey } from 'shared/utils/format-date-key';
import { useTheme } from 'styled-components';

import { UpcomingPeriod } from '../upcoming-period';
import * as Styled from './upcoming.style';
import { useUpcomingPeriods } from './use-upcoming-periods';

export type UpcomingProps = {
  task: Task;
  onEditSchedule?: () => void;
};

export const Upcoming: React.FC<UpcomingProps> = ({ task, onEditSchedule }) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const today = useToday();
  const periods = useUpcomingPeriods(task);

  const endedLabel = getHabitEndedLabel(
    getHabitEndedDate(task.schedules ?? [], today),
    t,
  );

  if (!periods.length && endedLabel) {
    return (
      <Styled.EmptyStateContainer>
        <Repeat
          width={20}
          height={20}
          strokeWidth={2}
          color={theme.palette.grey[600]}
        />
        <Styled.EmptyStateTitles>
          <Typography variant="h6">No active schedule</Typography>
          <Typography variant="overline" color={theme.palette.text.secondary}>
            {endedLabel}
          </Typography>
        </Styled.EmptyStateTitles>
        {!!onEditSchedule && (
          <Button
            color={Colors.TextPrimary}
            variant={Variants.Contained}
            size={Sizes.Small}
            onClick={onEditSchedule}
          >
            {t('task-detail.reschedule.habit-settings')}
          </Button>
        )}
      </Styled.EmptyStateContainer>
    );
  }

  return (
    <Styled.List>
      {periods.map((period) => (
        <Styled.ListItem key={formatDateKey(period.date)}>
          <UpcomingPeriod task={task} period={period} />
        </Styled.ListItem>
      ))}
    </Styled.List>
  );
};
